import { getSupabase } from '../../components/supabaseClient';
import { getBackendURL } from '../../components/env';

// Ask the backend to ADD COLUMN IF NOT EXISTS on a patient table. Admin-gated
// server-side; we attach the current Supabase session JWT as the bearer token.
export async function addColumns({ table, columns, schema, backendUrl = getBackendURL(), getClient = getSupabase, fetchImpl = fetch }) {
  if (!columns || columns.length === 0) return { added: [] };
  const client = await getClient();
  const { data } = await client.auth.getSession();
  const token = data && data.session && data.session.access_token;

  const res = await fetchImpl(`${backendUrl}/api/admin/patient-table/add-columns/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(schema ? { 'X-Schema': schema } : {}),
    },
    body: JSON.stringify({ schema, table, columns }),
  });

  if (!res.ok) {
    let msg = `Could not add columns (HTTP ${res.status})`;
    try { const j = await res.json(); if (j && j.error) msg = j.error; } catch (e) { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}
